import { render } from "./unifiChild2.vue?vue&type=template&id=2f35de0c&scoped=true"
import script from "./unifiChild2.vue?vue&type=script&lang=js"
export * from "./unifiChild2.vue?vue&type=script&lang=js"

import "./unifiChild2.vue?vue&type=style&index=0&id=2f35de0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f35de0c"]])

export default __exports__